import { Card, CardContent, CardHeader, CardTitle } from '@xhubio-saas/core-frontend/ui-components'
import { useTranslation } from 'react-i18next'

/**
 * Public imprint page (Impressum)
 */
export function ImprintPage() {
  const { t } = useTranslation()

  return (
    <Card className="w-full max-w-3xl mx-auto">
      <CardHeader>
        <CardTitle>{t('legal.imprintTitle', 'Impressum')}</CardTitle>
      </CardHeader>
      <CardContent className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
        <section>
          <h2 className="text-xl font-semibold mt-4 mb-4">
            {t('legal.imprint.companyTitle', 'Firma')}
          </h2>
          <p>
            {t(
              'legal.imprint.name',
              'BeeBack UG (haftungsbeschränkt), xhub.io is a digital service by BeeBack UG'
            )}
            <br />
            {t('legal.imprint.addressPlaceholder', 'Kreisstrasse 59')}
            <br />
            {t('legal.imprint.cityPlaceholder', '61118 Bad Vilbel')}
            <br />
            {t('legal.imprint.countryPlaceholder', 'Germany')}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-4">
            {t('legal.imprint.contactTitle', 'Kontakt')}
          </h2>
          <p>
            {t('legal.imprint.email', 'Email')}:{' '}
            {t('legal.imprint.emailPlaceholder', 'contact@pdf-api.xhub.io')}
            <br />
            {t('legal.imprint.phone', 'Phone')}:{' '}
            {t('legal.imprint.phonePlaceholder', '+49 160 7054331')}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-4">
            {t('legal.imprint.representativeTitle', 'Vertreten durch')}
          </h2>
          <p>{t('legal.imprint.representativePlaceholder', 'Patrick Jerominek')}</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-4">
            {t('legal.imprint.registrationTitle', 'Registereintrag')}
          </h2>
          <p>
            {t('legal.imprint.registrationCourt', 'Amtsgericht')}:{' '}
            {t('legal.imprint.registrationCourtPlaceholder', 'Frankfurt am Main')}
            <br />
            {t('legal.imprint.registrationNumber', 'Handelsregisternummer')}:{' '}
            {t('legal.imprint.registrationNumberPlaceholder', 'HRB 125402')}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-4">
            {t('legal.imprint.vatTitle', 'Umsatzsteuerinformationen')}
          </h2>
          <p>
            {t('legal.imprint.vatId', 'USt-IdNr.')}:{' '}
            {t('legal.imprint.vatIdPlaceholder', 'DE411970090')}
          </p>
        </section>
      </CardContent>
    </Card>
  )
}
